// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"MainPostsPage_SearchBar__13u57","SearchIcon":"MainPostsPage_SearchIcon__2kTV_","Clear":"MainPostsPage_Clear__1t_86","Badge":"MainPostsPage_Badge__2G7FW"};